<template>
	<div class="starfield" ref="container">
		<SmallStar v-for="n in 40" :key="n" :style="[randomScale(), randomPosition()]" :class="randomFill()"/>
		<slot/>
	</div>
</template>

<script>

import SmallStar from './illos/SmallStar'

export default {
	name: 'StarField',
	components: {
		SmallStar
	},
	data () {
		return {
			colours: [
				'yellow',
				'pink',
				'purple',
				'mint',
				'light-blue',
				'tangerine'
			]
		}
	},
	methods: {
		randomPosition () {
			return {
				left: Math.floor(Math.random() * (window.innerWidth - 20)),
				top: Math.floor(Math.random() * (window.innerHeight - 20))
			}
		},
		randomScale () {
			return { transform: 'scale(' + (Math.random() * 1.5) + ')' }
		},
		randomFill () {
			return this.colours[Math.floor(Math.random() * (this.colours.length - 1))]
		}
	}
}
</script>

<style scoped lang="stylus">

.starfield
	position absolute
	margin 0
	padding 0
	width 100%
	height 100%

	svg
		position absolute

	.yellow
		position absolute
		/deep/ .path
			fill rgba(250, 255, 17, 1)

	.pink
		/deep/ .path
			fill rgba(255, 0, 159, 1)

	.purple
		/deep/ .path
			fill rgba(76, 0, 251, 1)

	.mint
		/deep/ .path
			fill rgba(56, 200, 131, 1)

	.light-blue
		/deep/ .path
			fill rgba(1, 195, 203, 1)

	.tangerine
		/deep/ .path
			fill rgba(255, 171, 44, 1)
</style>
